<div *ngIf="selecionado">
    <app-estoque-amp-cadastro
      [model]="selecionado"
      (buscar)="buscar($event)"
      [state]="state">
    </app-estoque-amp-cadastro>
  </div>
  <div *ngIf="!selecionado">
    <app-estoque-amp-filtro [filtros]="filtros"></app-estoque-amp-filtro>
    <app-estoque-amp-lista
      [filtros]="filtros"
      (exibir)="selecionar($event)"
      (definirFiltro)="definirFiltro()">
    </app-estoque-amp-lista>
  </div>